export default __webpack_public_path__ + "static/media/contact-us-img.90d60634.jpg";